export default interface PassengerExtra {
  id: number
  amountCents: number
  name: string
  passengerId: number
  quantity: number
  valueType: PassengerExtraValueTypes
  extraType: PassengerExtraTypes
}

export enum PassengerExtraValueTypes {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum PassengerExtraTypes {
  Discount = 'discount',
  Extra = 'extra',
}
